"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const React = require("react");
function _interopNamespaceCompat(e) {
  if (e && typeof e === "object" && "default" in e) return e;
  const n = Object.create(null, { [Symbol.toStringTag]: { value: "Module" } });
  if (e) {
    for (const k in e) {
      n[k] = e[k];
    }
  }
  n.default = e;
  return Object.freeze(n);
}
const React__namespace = /* @__PURE__ */ _interopNamespaceCompat(React);
function createSlotsContext({
  displayName
}) {
  const SlotsContext = React__namespace.createContext({});
  SlotsContext.displayName = displayName;
  const SlotsProvider = ({ slots, children }) => {
    return /* @__PURE__ */ React__namespace.createElement(SlotsContext.Provider, { value: slots }, children);
  };
  const useSlots = () => {
    const context = React__namespace.useContext(SlotsContext);
    if (!context) {
      console.error(
        `No ${displayName} found. You might need to wrap your component in the Provider.`
      );
      return { Slots: {} };
    }
    return { Slots: context };
  };
  return [SlotsProvider, useSlots];
}
exports.createSlotsContext = createSlotsContext;
//# sourceMappingURL=create-context.js.map
